import PersonComment from './PersonComment.container';
export default PersonComment;
